import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import "./closedDisputes.css";
import Header from "../../../COMPONENTS/header/Header";
import { Link } from "react-router-dom";
import { useContext, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../../CONTEXT/AuthProvider";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import StatBox from "../../../COMPONENTS/StatBox";

function SearchedDisputes() {
  const navigate = useNavigate();
  const { auth } = useContext(AuthContext);
  const subscribername = auth.subscriberName;
  const staff = auth.staff;
  const accessToken = auth.accessToken;
  const digitalLendor = auth.digitalLendor;

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [searchedDisputes, setSearchedDisputes] = useState([]);
  const [countSearchedDisputes, setCountSearchedDisputes] = useState();

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const currentDate = new Date();

  const years = [];
  for (let i = 2000; i <= currentDate.getFullYear(); i++) {
    years.push(i);
  }

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const formatDate = (date) => {
    if (!date) return ""; // Handle null or undefined date
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Note: Month is zero-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const getMaxEndDate = () => {
    const today = new Date();
    const lastDateOfMonth = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    return lastDateOfMonth;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);

    const data = {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };

    if (staff === "Yes" || subscribername === "BANK OF TANZANIA") {
      try {
        const response = await axios.get(
          "/api/search-disputes",
          { params: data }, {
          headers: {
            'Authorization': 'Bearer ' + accessToken
          }
        }
        );

        // Check if the response contains an array
        if (Array.isArray(response.data)) {
          const dataResponse = response.data.map((assessment, index) => ({
            ...assessment,
            rowNumber: index + 1,
          }));
          setCountSearchedDisputes(dataResponse.length)
          setSearchedDisputes(dataResponse);
        } else {
          console.log("Response data is not an array:", response.data);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const response = await axios.get(
          "/api/search-disputes",
          { params: data }, {
          headers: {
            'Authorization': 'Bearer ' + accessToken
          }
        }
        );

        // Check if the response contains an array
        if (Array.isArray(response.data)) {
          const dataResponse = response.data
            .filter(
              (subscribers) => (subscribers["Subscriber Name"] === subscribername || subscribers["Subscriber Name"] === digitalLendor)
            )
            .map((assessment, index) => ({
              ...assessment,
              rowNumber: index + 1,
            }));
          setCountSearchedDisputes(dataResponse.length)
          setSearchedDisputes(dataResponse);
        } else {
          console.log("Response data is not an array:", response.data);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleView = (
    contractCode,
    subjectName,
    created,
    resolved,
    status,
    subscriberName,
    comments
  ) => {
    const closedDisputeDetails = {
      contractCode,
      subjectName,
      created,
      resolved,
      status,
      subscriberName,
      comments,
    };
    navigate("/ViewClosedDisputes", { state: { closedDisputeDetails } });
  };

  const columns = [
    {
      field: "rowNumber",
      headerName: "#",
      flex: 0.3,
    },
    {
      field: "Contract Code",
      headerName: "Contract Code",
      flex: 1,
    },
    {
      field: "Subject Name",
      headerName: "Subject Name",
      flex: 1.3,
    },
    {
      field: "Created",
      headerName: "Created",
      flex: 0.6,
    },
    {
      field: "Resolved",
      headerName: "Resolved",
      flex: 0.6,
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 0.6,
      renderCell: (params) => {
        const activeStatus = params.value;
        return <div className="closedCell">{activeStatus}</div>;
      },
    },
    {
      field: "Subscriber Name",
      headerName: "Subscriber Name",
      flex: 1.3,
    },
    {
      field: "Age Definition",
      headerName: "Due Time",
      flex: 0.7,
      renderCell: (params) => {
        const ageDefinition = params.value;
        const isExpired = ageDefinition.includes("Late");
        const cellClassName = isExpired ? "red-closed-cell" : "green-closed-cell";
        return <div className={cellClassName}>{ageDefinition}</div>;
      },
    },
    {
      field: "action",
      headerName: "Action",
      flex: 0.7,
      renderCell: (params) => {
        return (
          <>
            <button
              className="viewClosedDisputesButton"
              onClick={() =>
                handleView(
                  params.row["Contract Code"],
                  params.row["Subject Name"],
                  params.row.Created,
                  params.row.Resolved,
                  params.row.Status,
                  params.row["Subscriber Name"],
                  params.row.Comments
                )
              }
            >
              View
            </button>
          </>
        );
      },
    },
  ];
  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="8px">
          <Box m="8px">
            <Header
              title="CLOSED DISPUTES"
              subtitle="Search and assess closed disputes"
            />
          </Box>
          <div className="search-heading">
            <div className="count">
              <Box
                display="grid"
                gridTemplateColumns="repeat(12, 1fr)"
                gridAutoRows="140px"
                gap="20px"
              >
                <Box
                  gridColumn="span 20"
                  backgroundColor="#f2f0f0"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <StatBox
                    title={countSearchedDisputes || 0}
                    subtitle="Closed Disputes"
                    icon={
                      <LockOutlinedIcon
                        sx={{ color: "#70d8bd", fontSize: "26px" }}
                      />
                    }
                  />
                </Box>
              </Box>
            </div>
            <div className="report-heading">
              <div>
                <p className="head-title">Search by Date:</p>
              </div>
              <div className="datepicker">
                <div>
                  <DatePicker
                    className="searchDate"
                    placeholderText="Start Date"
                    renderCustomHeader={({
                      date,
                      changeYear,
                      changeMonth,
                      decreaseMonth,
                      increaseMonth,
                      prevMonthButtonDisabled,
                      nextMonthButtonDisabled,
                    }) => (
                      <div
                        style={{
                          margin: 0,
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          onClick={decreaseMonth}
                          disabled={prevMonthButtonDisabled}
                        >
                          {"<"}
                        </button>
                        <select
                          value={date.getFullYear()} // Use getFullYear() to get the year
                          onChange={({ target: { value } }) =>
                            changeYear(parseInt(value))
                          }
                        >
                          {years.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>

                        <select
                          value={months[date.getMonth()]} // Use getMonth() to get the month
                          onChange={({ target: { value } }) =>
                            changeMonth(months.indexOf(value))
                          }
                        >
                          {months.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>

                        <button
                          onClick={increaseMonth}
                          disabled={nextMonthButtonDisabled}
                        >
                          {">"}
                        </button>
                      </div>
                    )}
                    selected={startDate}
                    onChange={handleStartDateChange}
                    maxDate={getMaxEndDate()}
                    showMonthDropdown
                    showYearDropdown
                    dateFormat="dd-MM-yyyy"
                    dropdownMode="select"
                  />
                </div>
                <div>
                  <DatePicker
                    className="searchDate"
                    placeholderText="End Date"
                    renderCustomHeader={({
                      date,
                      changeYear,
                      changeMonth,
                      decreaseMonth,
                      increaseMonth,
                      prevMonthButtonDisabled,
                      nextMonthButtonDisabled,
                    }) => (
                      <div
                        style={{
                          margin: 0,
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          onClick={decreaseMonth}
                          disabled={prevMonthButtonDisabled}
                        >
                          {"<"}
                        </button>
                        <select
                          value={date.getFullYear()} // Use getFullYear() to get the year
                          onChange={({ target: { value } }) =>
                            changeYear(parseInt(value))
                          }
                        >
                          {years.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>

                        <select
                          value={months[date.getMonth()]} // Use getMonth() to get the month
                          onChange={({ target: { value } }) =>
                            changeMonth(months.indexOf(value))
                          }
                        >
                          {months.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>

                        <button
                          onClick={increaseMonth}
                          disabled={nextMonthButtonDisabled}
                        >
                          {">"}
                        </button>
                      </div>
                    )}
                    selected={endDate}
                    onChange={handleEndDateChange}
                    maxDate={getMaxEndDate()}
                    showMonthDropdown
                    showYearDropdown
                    minDate={startDate}
                    dateFormat="dd-MM-yyyy"
                    dropdownMode="select"
                  />
                </div>
                <div>
                  <Link className="link" onClick={handleSubmit}>
                    Search
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <Box m="8px">
            <Box
              m="40px 0 0 0"
              height="100vh"
              sx={{
                "& .MuiDataGrid-root": {
                  border: "none",
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "none",
                },
                "& .name-column--cell": {
                  color: "#2e7c67",
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#bbbbbb",
                  borderBottom: "none",
                },
                "& .MuiDataGrid-virtualScroller": {
                  backgroundColor: "#f2f0f0",
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "none",
                  backgroundColor: "#a4a9fc",
                },
                "& .MuiCheckbox-root": {
                  color: `${"#1e5245"} !important`,
                },
                "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                  color: `${"#525252"} !important`,
                },
              }}
            >
              <DataGrid
                rows={searchedDisputes}
                columns={columns}
                components={{ Toolbar: GridToolbar }}
              />
            </Box>
          </Box>
        </Box>
      </main>
    </div>
  );
}

export default SearchedDisputes;
